import styled from 'styled-components';

export const Container = styled.div`
    background: white;
    opacity: 1;
    height: 100%;
    flex-grow: 100;
    background-color: #ffffff;
    background-color: #fcfcff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23fcfcff' stroke-width='0.78' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cuse fill='%23f7f7fa' href='%23s' y='2'/%3E%3Cuse fill='%23f7f7fa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f2f2f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f2f2f5' href='%23s'/%3E%3Cuse fill='%23ededf0' href='%23s' x='2'/%3E%3Cuse fill='%23ededf0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23e8e8eb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23e8e8eb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23e3e3e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23fcfcff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23dedee0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23f2ebff'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23f2ebff'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(25.4) translate(-960.63 -720.47)'%3E%3Cg fill='%23f2ebff'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;

    > * {
        height: 1000%;
        min-height: 100%;
        width: 1000%;
    }
    position: relative;
}
`;

export const SaveButtonArea = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
}
`;

export const TitleInputArea = styled.div`
    position: absolute;
    left: 10px;
    top: 10px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
}
`;

export const ToolBoxArea = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
}
`;

export const FormArea = styled.div`
    position: absolute;
    right: 104px;
    top: 10px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
}
`;

export const ZoomArea = styled.div`
    position: absolute;
    right: 10px;
    Bottom: 12px;
    float: right;
    height: auto;
    width: auto;
    z-index: 100;
    min-height: auto;
    display: flex;
    flex-direction: column;
    > button {
        margin-top: 2px;
    }
}
`;
